import {computed, inject, provide, Ref, ref, watch, WatchStopHandle} from "vue";
import _ from "lodash";

const FormKey = Symbol.for("FormKey");

/**
 *
 */
export class ScForm {
    // 当前数据
    readonly data = ref<Record<string, any>>({});
    // 原数据
    readonly origin = ref<Record<string, any>>({});
    // 是否已获取其原数据
    readonly ready = ref(false);

    private protectWatch: WatchStopHandle;

    constructor() {
        provide(FormKey, this.data);
        this.protectWatch = watch([this.origin, this.data], () => {
            console.error("修改数据需要在init函数执行之后，或通过init函数修改", this.origin, this.data)
        }, {deep: true})
    }

    /**
     * 初始化原始数据
     * @param getOrigin
     */
    async init(getOrigin?: (() => Promise<Record<string, unknown>>) | Record<string, unknown>) {
        let data: Record<string, unknown>;
        if (typeof getOrigin === "function") {
            data = await getOrigin();
        } else {
            data = getOrigin || {};
        }
        this.protectWatch();
        this.origin.value = data;
        this.ready.value = true;
        this.reset();
    }

    static useFormData(): Ref {
        const form = inject(FormKey, undefined);
        if (!form) {
            throw new Error("没有注入的form");
        }
        return form;
    }

    public readonly canReset = computed(() => !_.isEqual(this.origin.value, this.data.value));

    reset() {
        this.data.value = _.cloneDeep(this.origin.value);
    }

    saveOrigin() {
        this.origin.value = _.cloneDeep(this.data.value);
    }
}
